/*
 * File: form-unit-number.ts
 * File Created: 2024-11-07 04:58:37
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-21 05:53:42
 * Modified By: Val Liu
 * -----
 */

import { Component } from "vue-property-decorator";
import { BaseFormComponent } from "../../core/lib/base-form-component";
import { PropInnateSync } from "@root/core/vue-props";
import { UITag } from "@root/core/tags";
import { makeRequiredValidator } from "@root/core/decorators/make-validator";
import { uiDescription } from "@root/core/tags/ui-description";

@Component
@UITag.setDefault({
    uiBlockAutofill: true,
    uiDescription: (o, element) => {
        return element?.$refs?.input?.description ?? null;
    },
})
export class FormUnitNumber extends BaseFormComponent {
    @PropInnateSync("value", { type: Number, required: false })
    innateValue!: number | undefined;

    /// private helpers
    // required validation for number
    @makeRequiredValidator({
        validator: (o) => !(o.value == null),
    })
    defaultRequired() {
        return undefined;
    }
}
export default FormUnitNumber;
